import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import config from '../../config';

let reactPlugin: ReactPlugin | null = null;
let appInsights: ApplicationInsights | null = null;

/**
 * Create the Telemetry Service for Application Insights
 */
const createTelemetryService = () => {
    /**
     * Initialize Application Insights
     * @param browserHistory - Client's browser history
     */
    const initialize = () => {
        if (!config.appInsightsConnectionString || config.environment === "dev") {
            console.warn('Application Insights not initialized: invalid environment or missing connection string.');
            return;
        }

        reactPlugin = new ReactPlugin();

        appInsights = new ApplicationInsights({
            config: {
                connectionString: config.appInsightsConnectionString,
                maxBatchInterval: 15000, // Send data in batches every 15 seconds
                enableAutoRouteTracking: true,
                disableFetchTracking: false,
                disablePageUnloadEvents: [ "unload" ],
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: { history: null }
                  }
            }
        });

        appInsights.loadAppInsights();

        //noise filtering added using:
        appInsights.addTelemetryInitializer((envelope) => {
            const telemetryItem = envelope.baseData;
            const url = telemetryItem?.data || "";
            const data = envelope.baseData as any;
            const method = data?.method || '';

            const isNoise = [
                '/favicon.ico',
                '/health',
                '/ping',
                'ai.monitoring.azure.com',
                'applicationinsights.azure.com'
            ].some(noisy => url.includes(noisy));

            if (isNoise || (method === 'OPTIONS')) {
                // prevent sending
                envelope.data = undefined;
            }
        });
        
    };

    return { reactPlugin, appInsights, initialize };
};

export const ai = createTelemetryService();

export const getAppInsights = () => {
    if (!appInsights) {
        if (config.environment === 'dev') {
            console.warn('Application Insights is not initialized. Falling back to console logging.');
        }
        return undefined;
    }
    return appInsights;
};

